import { IoClose } from 'react-icons/io5';
import { Container, Content } from './styles';

interface LeagueParticipants {
  id: number;
  isAdmin: boolean;
  pontos: number;
  username: string;
  foto: string;
}

interface CardProps {
  participant: LeagueParticipants;
  openKickPlayerModal: (participant: LeagueParticipants) => void;
}

export const Card: React.FC<CardProps> = ({
  participant,
  openKickPlayerModal,
}: CardProps) => {
  return (
    <Container>
      <Content>
        <span>
          <img
            src={
              participant.foto
                ? participant.foto
                : 'https://www.pinclipart.com/picdir/middle/157-1578186_user-profile-default-image-png-clipart.png'
            }
            alt={`Foto de ${participant.username}`}
          />
        </span>

        <div>
          <span>
            <h1>{participant.username}</h1>
            <h2>{participant.pontos} Pontos</h2>
          </span>
        </div>

        <button
          type="button"
          onClick={() => openKickPlayerModal(participant)}
          style={{ display: participant.isAdmin ? 'none' : 'flex' }}
        >
          <IoClose size={25} />
        </button>
      </Content>
    </Container>
  );
};
